<script setup lang="ts">
import coins from '@consumer/assets/icons/coins.svg'
import pencil from '@consumer/assets/icons/pencil.svg'
import seal from '@consumer/assets/icons/seal.svg'
import { openCustomizerModal } from '@consumer/services/modals'

defineProps<{
  howItWorks?: string
}>()
</script>

<template>
  <div class="font-semibold text-primary-base text-sm">The Giftly Advantage</div>
  <h2 class="font-semibold text-xl pb-4 pt-5">How it works</h2>
  <p class="mb-6">{{ howItWorks }}</p>

  <ul class="giftly-advantage-list pl-8">
    <li class="pl-2.5"><p>Easy to buy online. Have it delivered now or later.</p></li>
    <li class="pl-2.5"><p>Send it with a personalized greeting card.</p></li>
    <li class="pl-2.5"><p>3 easy ways for your recipient to redeem the gift.</p></li>
  </ul>

  <div class="flex flex-none items-start justify-between gap-4 pt-8">
    <div class="basis-1/3 flex flex-col gap-4 items-center">
      <img height="56" width="56" alt="alt Seal with a checkmark" :src="seal">
      <span class="text-sm font-semibold text-navy text-center">100%<br>Satisfaction<br>Guaranteed</span>
    </div>

    <div class="basis-1/3 flex flex-col gap-4 items-center">
      <img height="56" width="56" alt="alt A stack of coins" :src="coins">
      <span class="text-sm font-semibold text-navy text-center">No wasted balance</span>
    </div>

    <div class="basis-1/3 flex flex-col gap-4 items-center">
      <img height="56" width="56" alt="A pencil drawing" :src="pencil">
      <span class="text-sm font-semibold text-navy text-center">Easy to customize</span>
    </div>
  </div>

  <GButton
    href="/demo?spec=paid-landing"
    target="_giftly_demo"
    name="home-page-personalize-a-gift-button"
    size="large"
    secondary
    class="mt-5 w-full"
    label="See a Sample Gift"
    rel="nofollow"
  />
  <GButton
    name="home-page-shop-local-gifts-button"
    size="large"
    primary
    class="mt-3 w-full"
    label="Customize & Buy"
    @click="openCustomizerModal({
      gift: {},
      specOptions: { purchaseMethod: 'giftly-advantage', spec: 'buy-a-gift' },
    })"
  />
</template>

<style lang="scss" scoped>
.giftly-advantage-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  list-style-image: url("@consumer/assets/icons/blue-square.svg");
}
</style>
